import * as m from "@/paraglide/messages"
import TriangleWarning from "@/shared/assets/coolicons/Warning/Triangle_Warning.svg?react"

interface ReportFriendButtonProps {
	friendId: number
	onReport?: (friendId: number) => void
}

export function ReportFriendButton({
	friendId,
	onReport,
}: ReportFriendButtonProps) {
	const handleReport = () => {
		onReport?.(friendId)
	}

	return (
		<button
			type="button"
			onClick={handleReport}
			className="relative isolate flex h-[47px] w-full flex-col items-start justify-center gap-1.75 rounded-b-lg bg-white px-3 py-0"
		>
			{/* Divider */}
			<div className="absolute inset-x-[4.46%] top-0 h-px bg-[#d9dce5]" />

			<div className="flex w-full flex-row items-center justify-start gap-2.5">
				<TriangleWarning className="size-6 shrink-0 text-[#282a33]" />
				<span className="text-center text-base leading-5 font-medium text-[#282a33]">
					{m.friendProfileBtnReport()}
				</span>
			</div>
		</button>
	)
}
